<template>
    <TableLayout :permissions="['renthouse:rhchatlog:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="发起方" prop="startUser">
                <el-input v-model="searchForm.startUser" placeholder="请输入发起方" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="接收人" prop="targetUser">
                <el-input v-model="searchForm.targetUser" placeholder="请输入接收人" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="房源名称" prop="houseTitle">
                <el-input v-model="searchForm.houseTitle" placeholder="请输入房源名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="楼栋号" prop="buildingNum">
                <el-input v-model="searchForm.buildingNum" placeholder="请输入楼栋号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="门牌号" prop="roomNum">
                <el-input v-model="searchForm.roomNum" placeholder="请输入门牌号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="发起人手机号" prop="startUserPhone">
                <el-input v-model="searchForm.startUserPhone" placeholder="请输入发起人手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="接收人手机号" prop="targetUserPhone">
                <el-input v-model="searchForm.targetUserPhone" placeholder="请输入接收人手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="消息类型" prop="relatedType">
                <el-select v-model="searchForm.relatedType" placeholder="请选择" @change="search">
                    <el-option label="位置信息" :value="0"></el-option>
                    <el-option label="房源信息" :value="1"></el-option>
                    <el-option label="合同信息" :value="2"></el-option>
                    <el-option label="收款码" :value="3"></el-option>
                    <el-option label="系统消息" :value="4"></el-option>
                    <el-option label="自定义信息" :value="5"></el-option>
                    <el-option label="常用语消息" :value="17"></el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="chatId" label="聊天室id" min-width="100px"></el-table-column>
                <el-table-column prop="startUserName" label="发起方" min-width="100px"></el-table-column>
                <el-table-column prop="startUserPhone" label="发起方手机号" min-width="100px"></el-table-column>
                <el-table-column prop="targetUserName" label="接收人" min-width="100px"></el-table-column>
                <el-table-column prop="targetUserPhone" label="接收人手机号" min-width="100px"></el-table-column>
                <el-table-column prop="content" label="聊天内容" min-width="100px"></el-table-column>
                <el-table-column label="类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.relatedType === 0">位置信息</span>
                        <span v-else-if="row.relatedType === 1">房源信息</span>
                        <span v-else-if="row.relatedType === 2">合同信息</span>
                        <span v-else-if="row.relatedType === 3">收款码</span>
                        <span v-else-if="[4,8,9,10,11,12,13,14].includes(row.relatedType)">系统消息</span>
                        <span v-else>普通聊天信息</span>
                    </template>
                </el-table-column>
                <el-table-column label="信息" min-width="100px">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="getHouse(row.houseId)" v-show="row.houseId">查看房源</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="发送时间" min-width="100px"></el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <OperaRhHouseWindow ref="operaRhHouseWindow" />
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRhHouseWindow from '@/components/rentHouse/OperaRhHouseWindow'
import { fetchList as house } from '@/api/rentHouse/rhHouse'
export default {
  name: 'RhChatLog',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRhHouseWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        startUser: '',
        targetUser: '',
        houseTitle: '',
        buildingNum: '',
        roomNum: '',
        startUserPhone: '',
        targetUserPhone: '',
        relatedType: ''
      }
    }
  },
  created () {
    this.config({
      module: '聊天室信息记录',
      api: '/rentHouse/rhChatLog',
      'field.id': 'id',
      'field.main': 'id',
      sorts: [{
        property: 'CREATE_TIME',
        direction: 'DESC'
      }]
    })
    this.search()
  },
  methods: {
    getHouse (row) {
      house({
        capacity: 10,
        page: 1,
        model: {
          id: row
        }
      }).then(res => {
        this.$refs.operaRhHouseWindow.open('房源详情', { ...res.records[0], seeType: 'desc' })
      })
    }
  }
}
</script>
